'use strict';

exports.__esModule = true;
var ALERTA = exports.ALERTA = 'alerta';
var ALERTA_POPUP = exports.ALERTA_POPUP = 'popup';